import { httpMethod, useApi } from './useApi';
export const useCreateFlowLog = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flow-logs',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetFlowLogs = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flow-logs',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: {},
    });
    const callFunction = (request) => {
        const queryParams = {};
        if (request?.flowId) {
            queryParams['filters'] = JSON.stringify({ flow_id: request.flowId });
        }
        // console.log(queryParams);
        call(queryParams);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useUpdateFlowLog = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'flow-logs',
        httpMethod: httpMethod.PUT,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
// export const useDeleteFlowLog = () => {
//   const { call, data, error, ...rest } = useApi({
//     authenticated: true,
//     path: 'flow-logs',
//     httpMethod: httpMethod.DELETE,
//     body: {},
//   });
//   const callFunction = (body: RequestDELETESchemaType) => {
//     call(body);
//   };
//   const responseData = data as ResponseDELETESchemaType;
//   return { call: callFunction, data: responseData, error, ...rest };
// };
